import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TResetMainArticles, EResetMainArticlesActionType } from './types';

export const resetMainArticles: () => TResetMainArticles = actionGenerator<EResetMainArticlesActionType.Reset>(
  EResetMainArticlesActionType.Reset,
);
